import React, { useState } from "react";

const CustomScanITReference = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-white rounded-2xl shadow-xl overflow-hidden mt-8">
      <div className="p-6 border-b border-gray-100 flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-900">
          FOR I.T Reference: Custom Scan URL Protocol Setup
        </h2>
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className="text-indigo-600 hover:text-indigo-800 text-sm"
          aria-label="Toggle I.T reference"
        >
          {isOpen ? "Hide" : "Show"}
        </button>
      </div>
      {isOpen && (
        <div className="p-6 space-y-4 text-sm text-gray-700">
          <p className="text-sm text-gray-500">
            Setup ng custom URL protocol para sa customscan://open
          </p>
          <div>
            <p className="font-semibold">Step 1: Buksan ang Registry Editor</p>
            <p>Win + R, type regedit, then Enter.</p>
            <p>Kapag may UAC prompt, piliin Yes.</p>
          </div>
          <div>
            <p className="font-semibold">Step 2: Magdagdag ng Protocol Key</p>
            <p>Navigate sa HKEY_CLASSES_ROOT.</p>
            <p>Right-click - New - Key - pangalanan: customscan</p>
            <p>(Default) value: URL:Custom Scan Protocol</p>
            <p>Magdagdag ng string value: URL Protocol (value empty)</p>
          </div>
          <div>
            <p className="font-semibold">
              Step 3: Magdagdag ng Command para buksan ang EXE
            </p>
            <p>Sa loob ng customscan key, gumawa ng keys:</p>
            <p>shell - open - command</p>
            <p>
              (Default) value ng command key:
              {" "}
              "C:\Path\To\Custom Scan App.exe" "%1"
            </p>
            <p>
              Example:
              {" "}
              "C:\Program Files\AMAPHIL\Custom Scan App.exe" "%1"
            </p>
          </div>
          <div>
            <p className="font-semibold">Step 4: Test</p>
            <p>Sa browser, i-type: customscan://open</p>
            <p>Kapag tama ang registry, magbubukas ang EXE.</p>
          </div>
          <div>
            <p className="font-semibold">Optional Tip: Shortcut sa React</p>
            <pre className="bg-gray-50 p-3 rounded-lg text-xs overflow-x-auto">
{`<button onClick={() => window.location.href = "customscan://open"}>
  Open Custom Scan App
</button>`}
            </pre>
          </div>
          <div>
            <p className="font-semibold">One-click .reg file</p>
            <p>
              Edit the EXE path inside
              {" "}
              customscan_protocol.reg, then double-click to import.
            </p>
            <p>
              File location:
              {" "}
              app/Http/Controllers/Claims/other-files-references/Custom Scan App/customscan_protocol.reg
            </p>
            <pre className="bg-gray-50 p-3 rounded-lg text-xs overflow-x-auto">
{`Windows Registry Editor Version 5.00

[HKEY_CLASSES_ROOT\\customscan]
@="URL:Custom Scan Protocol"
"URL Protocol"=""

[HKEY_CLASSES_ROOT\\customscan\\shell]

[HKEY_CLASSES_ROOT\\customscan\\shell\\open]

[HKEY_CLASSES_ROOT\\customscan\\shell\\open\\command]
@="\\"C:\\\\Path\\\\To\\\\Custom Scan App.exe\\" \\"%1\\""`}
            </pre>
            <p>Note: Double backslashes \\ are required in .reg files.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomScanITReference;
